export default "__VITE_ASSET__C$0opeQ9__"